import { useMemo } from 'react'

import { type BrokersTaskDetail } from 'utils/web_api.schemas'

export const useTaskMetadata = (task: BrokersTaskDetail | null | undefined) => {
  const metadata = useMemo(() => {
    return (task?.metadata ?? {}) as Record<string, unknown>
  }, [task?.metadata])

  const instructions = useMemo(() => {
    const value = metadata?.instructions
    return typeof value === 'string' ? value : undefined
  }, [metadata])

  const runbookUrl = useMemo(() => {
    const urlCandidates = [
      metadata?.runbook_url,
      metadata?.notion_runbook_url,
      metadata?.notion_url,
    ]
    const firstUrl = urlCandidates.find(
      (candidate) => typeof candidate === 'string' && candidate.length > 0
    )
    return typeof firstUrl === 'string' ? firstUrl : undefined
  }, [metadata])

  const scribeUrl = useMemo(() => {
    const value = metadata?.scribe_url
    return typeof value === 'string' ? value : undefined
  }, [metadata])

  return {
    metadata,
    instructions,
    runbookUrl,
    scribeUrl,
  }
}
